"use strict";import{tag as l}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const Dash75Icon=({width:t=24,height:e=24,hidden:a=!1,title:r="Dash75"}={})=>l`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 8 8"
    aria-hidden=${a?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${r}"
    width="${t}"
    height="${e}"
  >
    <path d="M6.99 4.96H1.01a.96.96 0 0 1 0-1.92h5.98a.96.96 0 0 1 0 1.92" />
  </svg>`;
//# sourceMappingURL=Dash75.js.map
